import { AppThunk } from "@rdx/store";
import {createSlice} from "@reduxjs/toolkit";

const adapterSlice = createSlice({
    name : "adapters",
    initialState : {
        data: null
    },
    reducers : {
        loadAdapterForMutation : (state, action) => {
            
        },
        resetAdapter : (state) => {
            
        },
        signalRState : (state, action) => {
            state.data = action.payload;
        }
    }
})

const {actions, reducer} = adapterSlice;

export const {loadAdapterForMutation, resetAdapter, signalRState} = actions;

export const loadAndPersistAdapterForMutation = (payload: any): AppThunk => {
    return dispatch => {
        sessionStorage.setItem("adapterMutation", JSON.stringify(payload));
        dispatch(loadAdapterForMutation(payload))
    }
}

export const resetAdapterForMutation = (): AppThunk => {
    return dispatch => {
        dispatch(resetAdapter())
    }
} 

export default reducer;